import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

import { isStepEnabled } from '../../../utils/compound';
import ClosingRangePicker from '../../common/ClosingRangePicker';
import CompoundOptionsContainer from '../../compound/OptionsContainer';
import StepHeader from './StepHeader';

const StyledMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 10px 10px;
  flex: 1;
  width: 100%;

  .closing-range-picker-container {
    margin-top: 8px;
    margin-bottom: 16px;
  }

  .funnel-update-step-filter-container {
    border-top: 1px solid #d9d9d9;
    margin-top: 8px;
    padding-top: 8px;
  }
`;

// TODO put the stepNum inside the circle
// TODO we should get rid of stepIndex term in favor of smth like stepId
const FunnelUpdateStep = ({
  removeStep,
  setEventName,
  toggleEnabled,
  setClosingRange,
  setOptionalStatus,
  setStepCount,
  first,
  label,
  events,
  event,
  closingRange,
  filter,
  stepIndex,
  enabled,
  optional,
  count,
  countOperator,
  perStepClosingRangeEnabled,
  renderStepFilter,
  fromDashboard,
  showNotValidFields,
  isOnlyEnabledStep,
  setLegendName,
  legendName,
}) => (
  <>
    <StyledMainContainer
      className={classNames(!isStepEnabled(enabled) && 'st-funnel-step-container-disabled')}
    >
      <StepHeader
        optional={optional}
        label={label}
        event={event}
        events={events}
        first={first}
        removeStep={removeStep}
        setEventName={setEventName}
        showNotValidFields={showNotValidFields}
        enabled={enabled}
        onChangeLegendName={setLegendName}
        legendName={legendName}
        fromDashboard={fromDashboard}
      />
      {first || !perStepClosingRangeEnabled ? null : (
        <div className="closing-range-picker-container">
          <ClosingRangePicker
            closingRange={closingRange}
            onChange={setClosingRange}
            selectClassName="ant-select-border-bottom"
            inputClassName="ant-input-border-bottom"
          />
        </div>
      )}
      <div className="funnel-update-step-filter-container">
        {renderStepFilter({ stepIndex, event, filter })}
      </div>
    </StyledMainContainer>
    <CompoundOptionsContainer
      showEnabled
      enabled={isStepEnabled(enabled)}
      onEnabledStatusChange={toggleEnabled}
      showOptional={!first}
      optional={!!optional}
      onOptionalStatusChange={setOptionalStatus}
      showCount
      count={count}
      countOperator={countOperator}
      onCountChange={setStepCount}
      fromDashboard={fromDashboard}
      isOnlyEnabledStep={isOnlyEnabledStep}
    />
  </>
);

export default FunnelUpdateStep;
